import { FormSection, FormRow, MediumFormRow, BigFormRow } from 'framework/ui/layout';
import { NumberInput, EnumDropdown, InputList, ClearAfterUnmountWrapper } from 'framework/form';
import { PositionSlotWorkingConditionsInputListTemplate } from '../shared/inputs/WorkingConditionsInputs';
import ProjectDescriptionInputs from '../shared/inputs/ProjectDescriptionInputs';
import { SkillsInput } from 'domain/recruiting/shared/skills';
import { NoteAttachmentUploaderInput } from 'domain/shared/artifact/input';
import { EXPIRATION_PERIOD_OPTIONS, HIRING_MODE } from 'domain/shared/newVacancy';
import VacancyWysiwygInput from '../../vacancy/shared/input/VacancyWysiwygInput';
import TargetHireDateInput from '../shared/inputs/TargetHireDateInput';
import useCommonSkillsService from 'domain/recruiting/candidate/commonskills/commonSkillsService';
import { ENGLISH_LEVEL_SHORT_OPTIONS } from 'domain/shared/core/constants';
import VacancyPositionSlotsInput from '../shared/inputs/positionSlots/VacancyPositionSlotsInput';

const VacancyPositionSlotForm = () => {
  const { searchByName } = useCommonSkillsService();

  return (
    <>
      <FormSection title="Position slots">
        <BigFormRow>
          <VacancyPositionSlotsInput />
        </BigFormRow>
      </FormSection>

      <FormSection title="Main information">
        <FormRow>
          <EnumDropdown
            options={EXPIRATION_PERIOD_OPTIONS}
            source="expirationPeriodInMonth"
            label="Expiration period (Month)"
            placeholder="Select period"
          />
          <EnumDropdown
            tooltip={
              <>
                Active hiring mode means that a new position is available and the person is needed to fill it.
                <br />
                Bar raiser means that no additional positions are available, but the staffing coordinator will replace
                low-performers with the hired person.
              </>
            }
            options={HIRING_MODE}
            source="hiringMode"
            label="Hiring mode"
            placeholder="Select mode"
          />
        </FormRow>
        <FormRow>
          <TargetHireDateInput />
        </FormRow>
      </FormSection>

      <FormSection title="Working conditions">
        <FormRow colMd={12} colXl={12}>
          <ClearAfterUnmountWrapper>
            <InputList
              minFields={1}
              source="workingConditions"
              addText="Add location"
              maxFields={10}
              inputTemplate={PositionSlotWorkingConditionsInputListTemplate}
            />
          </ClearAfterUnmountWrapper>
        </FormRow>
      </FormSection>

      <FormSection title="Project description">
        <InputList source="projects" addText="Add project" maxFields={10} inputTemplate={ProjectDescriptionInputs} />
      </FormSection>

      <FormSection title="Responsibilities*">
        <BigFormRow>
          <VacancyWysiwygInput source="responsibilities" label="" />
        </BigFormRow>
      </FormSection>

      <FormSection title="Mandatory requirements">
        <BigFormRow>
          <VacancyWysiwygInput source="mandatoryRequirements.description" label="" />
        </BigFormRow>

        <MediumFormRow>
          <SkillsInput
            source="mandatoryRequirements.skills"
            loadSuggestionsMethod={searchByName}
            label="Skills"
            helpText="Required skills for the Vacancy. These skills will be used for Candidate matching purposes and will not be publicly displayed."
          />
        </MediumFormRow>

        <FormRow>
          <NumberInput source="mandatoryRequirements.requiredExperienceInYears" label="Required Experience (years)" />

          <EnumDropdown
            source="mandatoryRequirements.englishLevel"
            label="English level"
            options={ENGLISH_LEVEL_SHORT_OPTIONS}
            placeholder="Choose english level"
          />
        </FormRow>
      </FormSection>

      <FormSection title="Optional requirements">
        <BigFormRow>
          <VacancyWysiwygInput source="optionalRequirements.description" label="" />
        </BigFormRow>

        <MediumFormRow>
          <SkillsInput
            source="optionalRequirements.skills"
            loadSuggestionsMethod={searchByName}
            label="Skills:"
            helpText="Optional skills for the Vacancy. These skills will be used for Candidate matching purposes and will not be publicly displayed."
          />
        </MediumFormRow>
      </FormSection>

      <FormSection title="Notes">
        <BigFormRow>
          <VacancyWysiwygInput source="notes.description" label="" />
        </BigFormRow>
        <FormRow>
          <NoteAttachmentUploaderInput label="Attachments" source="notes.attachmentIds" />
        </FormRow>
      </FormSection>
    </>
  );
};

export default VacancyPositionSlotForm;
